@if (isLoading$ | async; as isLoading) {
<div class="loader-overlay">
    <div class="spinner"></div>
    <div class="loader-text">
        {{ text$ | async }}
        <span class="dots">
            @for (dot of [1,2,3]; track dot) {
            <span [class.active]="isLoading">{{'.'}}</span>
            }
        </span>
    </div>
</div>
}